import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { clearSession } from '~/lib/session';
import { logout } from '~/lib/network/auth';
import { useGlobalStore } from '~/stores/store-provider';

export default function Logout() {
    const navigate = useNavigate();
    const resetAll = useGlobalStore((state: any) => state.resetAll);

    useEffect(() => {
        const performLogout = async () => {
            try {
                // Clear HttpOnly cookie via backend endpoint
                await logout();
            } catch (e) {
                // Continue with logout even if backend call fails
                console.error('Logout API call failed:', e);
            }
            // Clear local session data
            clearSession();
            resetAll();
            navigate('/', { replace: true });
        };

        performLogout();
    }, [navigate, resetAll]);

    return null;
}
